var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.input),expression:"input"}],staticClass:"resize-none",domProps:{"value":(_vm.input)},on:{"keydown":_vm.keydown,"input":function($event){if($event.target.composing)return;_vm.input=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }